import React, { useState } from "react";
import { connect } from "react-redux";
import {
  CustomerListModel,
  MajorCompanyDto,
  SurveyTypeListDto,
  DataVendorCostAllocationRequestCustomerDetails,
} from "interfaces/Mueller.Business.Models";
import { InitialState } from "reducers/initialState";
import { MSelectOptionStringValue, MSelectOptionNumberValue } from "typeConstants/employeeCustomerSurveyTypes";
import MSelect from "../MSelect";
import { Button, TextField } from "@mui/material";

interface TechCostCustomerSurveyTypeChooserProps {
  onSave: (newEntry: DataVendorCostAllocationRequestCustomerDetails) => void;
  onCancel: () => void;
  // Redux
  majorCompanies: MajorCompanyDto[];
  customerList: CustomerListModel[];
  allSurveyTypes: SurveyTypeListDto[];
}

const TechCostCustomerSurveyTypeChooser = (props: TechCostCustomerSurveyTypeChooserProps) => {
  const [majorCompany, setMajorCompany] = useState<MSelectOptionStringValue | null>();
  const [customerAccount, setCustomerAccount] = useState<MSelectOptionNumberValue | null>();
  const [surveyType, setSurveyType] = useState<MSelectOptionStringValue | null>();
  const [weight, setWeight] = useState<number>();

  const onSelectMajorCompany = (newValue: MSelectOptionStringValue) => {
    setMajorCompany(newValue);
    setCustomerAccount(null);
    setSurveyType(null);
  };
  const onSelectCustomer = (newValue: MSelectOptionNumberValue) => {
    setCustomerAccount(newValue);
    setSurveyType(null);
  };
  const onSelectSurveyType = (newValue: MSelectOptionStringValue) => setSurveyType(newValue);

  const isValid = (majorCompany || customerAccount || surveyType) && weight > 0;

  const handleSave = () => {
    const newEntry: DataVendorCostAllocationRequestCustomerDetails = {
      majorCompanyCode: majorCompany?.value,
      customerNumber: customerAccount?.value,
      surveyTypeCode: surveyType?.value,
      weight: weight,
    };
    props.onSave(newEntry);
  };

  const filteredCustomers = majorCompany
    ? props.customerList.filter((c) => c.majorCompany.code === majorCompany.value)
    : props.customerList;
  const customerOptions = filteredCustomers.map((c) => ({ label: `${c.number} ${c.displayName}`, value: c.number }));

  const filteredSurveyTypeCodes = customerAccount
    ? props.customerList.find((c) => c.number === customerAccount.value)?.activeSurveyTypeCodes
    : filteredCustomers.reduce((acc, cur) => acc.concat(cur.activeSurveyTypeCodes || []), []);
  const surveyTypeOptions = props.allSurveyTypes
    .filter((s) => filteredSurveyTypeCodes.includes(s.code))
    .map((s) => ({ label: s.name, value: s.code }));

  return (
    <div className="dialog-content-container">
      <MSelect
        className="tech-cost-major-company"
        key="tech-cost-major-company"
        label="Select Major Company (optional)"
        placeholder="Select Major Company (optional)"
        onChange={onSelectMajorCompany}
        options={props.majorCompanies?.map((c) => ({ label: `${c.companyName}`, value: c.code }))}
        value={majorCompany}
        enableAllOption={false}
        menuPlacement="bottom"
      />
      <MSelect
        className="tech-cost-customer"
        key="tech-cost-customer"
        label="Select Customer (optional)"
        placeholder="Select Customer (optional)"
        onChange={onSelectCustomer}
        options={customerOptions}
        value={customerAccount}
        enableAllOption={false}
        menuPlacement="bottom"
      />
      <MSelect
        className="tech-cost-survey-type"
        key="tech-cost-survey-type"
        label="Select Survey Type (optional)"
        placeholder="Select Survey Type (optional)"
        onChange={onSelectSurveyType}
        options={surveyTypeOptions}
        value={surveyType}
        enableAllOption={false}
        menuPlacement="bottom"
      />
      <TextField
        type="number"
        value={weight}
        label="Weight"
        placeholder="Enter weight"
        onChange={(newValue) => setWeight(Number(newValue.target.value))}
      />
      <div className="flex-row-between">
        <Button onClick={handleSave} disabled={!isValid}>
          Add
        </Button>
        <Button onClick={props.onCancel}>Cancel</Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: InitialState) => ({
  majorCompanies: state.customer.majorCompanies,
  customerList: state.customer.customerList,
  allSurveyTypes: state.user.allSurveyTypes,
});

export default connect(mapStateToProps, null)(TechCostCustomerSurveyTypeChooser);
